import React from "react";
import styles from "../styles/Sizeup.module.css";

const SizeupButton = ({ btnClickHandler, btnText }) => {

  return (
    <button
      className={`find-counselor py-6 ${styles.findcounselor} !mt-0`}
      onClick={btnClickHandler}
    >
      {btnText}
    </button>
  );
};

export default SizeupButton;
